import React, { useEffect, useState, useCallback } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FiHome,
  FiPlusSquare,
  FiList,
  FiUser,
  FiLogOut,
  FiUsers,
  FiArrowRightCircle,
  FiUserPlus,
  FiArrowLeftCircle,
  FiClipboard,
  FiXCircle,
  FiEdit2,
  FiEye,
  FiFileText,
  FiSettings,
} from 'react-icons/fi';
import './menu.css';
import { MENU_LOGO_SRC, MENU_LOGO_ALT } from './menuLogo';
import SidebarCollapseButton from './SidebarCollapseButton';

export default function Menubinder({ defaultOpen = true, onToggle }) {
  const [open, setOpen] = useState(defaultOpen);
  const navigate = useNavigate();

  useEffect(() => {
    onToggle && onToggle(open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = useCallback(() => {
    const next = !open;
    setOpen(next);
    onToggle && onToggle(next);
  }, [open, onToggle]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    navigate('/');
  };

  const handleBack = () => {
    navigate('/inicioGeneral');
  };

  const logoMaskStyle = {
    '--ops-logo-mask': `url(${MENU_LOGO_SRC})`,
  };

  return (
    <aside className={`ops-menu ops-menu--general ${open ? 'open' : 'collapsed'}`}>
      <SidebarCollapseButton open={open} onToggle={toggle} controls="gestion-sidebar-content" />
      <div className="ops-menu-content" id="gestion-sidebar-content">
      <div className="ops-menu-header">
        <div
          className="ops-logo"
          style={logoMaskStyle}
          onClick={() => navigate('/inicio')}
        >
          <img src={MENU_LOGO_SRC} alt={MENU_LOGO_ALT} />
      
        </div>
      </div>

      <nav className="ops-nav">
        <NavLink to="/inicio" title="Inicio" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiHome /> <span>Inicio</span>
        </NavLink>
        <NavLink to="/cliente" title="Agregar Clientes" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiUserPlus /> <span>Agregar Clientes</span>
        </NavLink>

        <div className="ops-nav-group">
          <NavLink to="/ingreso" title="Nuevo Ingreso" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
            <FiPlusSquare /> <span>Nuevo Ingreso</span>
          </NavLink>
          <div className="ops-subnav">
            <NavLink to="/anularremito" title="Anular remitos" className={({ isActive }) => `ops-subnav-item ${isActive ? 'active' : ''}`}>
              <FiXCircle /> <span>Anular remitos</span>
            </NavLink>
            <NavLink to="/remitos-anulados" title="Remitos anulados" className={({ isActive }) => `ops-subnav-item ${isActive ? 'active' : ''}`}>
              <FiEye /> <span>Remitos anulados</span>
            </NavLink>
            <NavLink to="/modificar-ingreso" title="Modificar ingreso" className={({ isActive }) => `ops-subnav-item ${isActive ? 'active' : ''}`}>
              <FiEdit2 /> <span>Modificar ingreso</span>
            </NavLink>
          </div>
        </div>

     
        <NavLink to="/egreso" title="Egreso" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiArrowRightCircle /> <span>Egreso</span>
        </NavLink>
        <NavLink to="/pedidos" title="Pedidos" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiClipboard /> <span>Pedidos</span>
        </NavLink>
        <NavLink to="/facturacion" title="Facturación" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiFileText /> <span>Facturación</span>
        </NavLink>

        <NavLink to="/pallets" title="Stock" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiList /> <span>Stocks</span>
        </NavLink>

        <NavLink to="/usuarios" title="Usuarios" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiUsers /> <span>Usuarios</span>
        </NavLink>

        <NavLink to="/configuracion" title="Configuracion" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiSettings /> <span>Configuracion</span>
        </NavLink>

        <NavLink to="/perfil" title="Perfil" className={({ isActive }) => `ops-nav-item ${isActive ? 'active' : ''}`}>
          <FiUser /> <span>Perfil</span>
        </NavLink>
      </nav>

      <div className="ops-nav" style={{ marginTop: 'auto', padding: '12px 18px' }}>
          <button type="button" className="ops-nav-item clickable" onClick={handleBack}>
          <FiArrowLeftCircle /> <span>Volver</span>
        </button>
        <button className="ops-nav-item clickable" onClick={handleLogout} style={{ width: '100%' }}>
          <FiLogOut /> <span>Cerrar sesión</span>
        </button>
      </div>
      </div>
    </aside>
  );
}
